import { Component, OnInit } from '@angular/core';
import { SecurityService } from '../security.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout-callback',
  templateUrl: './logout-callback.component.html'
})
export class LogoutCallbackComponent implements OnInit {

  constructor(private securityService: SecurityService,
    private router: Router) { }

    ngOnInit(): void {
      this.securityService.logout();
      this.router.navigateByUrl('/secure');
    }

  }
